import HCLDX from '@system/config/hcldx';
import System from 'src/helper/system';
import Helper from 'src/support/Helper';
import { isNumber } from 'underscore';

class ResponseMaker {
    data = [];
    data_to_send = ResponseMaker.defaultData();

    constructor(data) {
        this.data = data;
    }

    static defaultData = () => {
        return {
            allTabsCount: {},
            allContentCount: {
                articleCount: 0,
                eventCount: 0,
                otherCount: 0,
                videoCount: 0,
            },
            allContentList: {},
            allContentVideoList: {},
            articleContentList: {
                searchFacets: [],
                list: []
            },
            eventContentList: {},
            sitePageContentList: {},
            videoContentList: {
                searchFacets: {},
                list: []
            },
            npiContentList: {},
            totalContentList: 0
        };
    }
    process = async () => {
        let value = [];
        let countResp = ResponseMaker.defaultData().allContentCount;
        let dataList = this.data && this.data.data;

        if (dataList) {
            if (dataList.articlecount !== undefined &&
                dataList.articlecount !== null &&
                isNumber(dataList.articlecount)) {
                countResp['articleCount'] = dataList.articlecount
            }
            if (dataList.eventcount !== undefined &&
                dataList.eventcount !== null &&
                isNumber(dataList.eventcount)) {
                countResp['eventCount'] = dataList.eventcount;
            }
            if (dataList.othercount !== undefined &&
                dataList.othercount !== null &&
                isNumber(dataList.othercount)) {
                countResp['otherCount'] = dataList.othercount;
            }
            if (dataList.videoCount !== undefined &&
                dataList.videoCount !== null &&
                isNumber(dataList.videoCount)) {
                countResp['videoCount'] = dataList.videoCount;
            }
        }

        this.data_to_send.allContentCount = countResp;

        // Prepare Tabs Count 
        let tabResp = {};
        if (dataList) {
            if (dataList.npiCount !== undefined && dataList.npiCount !== null && isNumber(dataList.npiCount)) {
                tabResp['npiCount'] = dataList.npiCount
            }
            if (dataList.productCount !== undefined && dataList.productCount !== null && isNumber(dataList.productCount)) {
                tabResp['productCount'] = dataList.productCount
            }
            if (dataList.videoCount !== undefined && dataList.videoCount !== null && isNumber(dataList.videoCount)) {
                tabResp['videoCount'] = dataList.videoCount
            }
            if (dataList.docCount !== undefined && dataList.docCount !== null && isNumber(dataList.docCount)) {
                tabResp['documentCount'] = dataList.docCount
            }
            if (dataList.moreCount !== undefined && dataList.moreCount !== null && isNumber(dataList.moreCount)) {
                tabResp['moreCount'] = dataList.docCount
            }
        }

        this.data_to_send.allTabsCount = tabResp;

        // Prepare List 
        if (dataList) {
            if (dataList.allContentList !== undefined &&
                dataList.allContentList !== null) {
                if (dataList.allContentList.recordSetTotal !== undefined &&
                    dataList.allContentList.recordSetTotal !== null &&
                    Number(dataList.allContentList.recordSetTotal) > 0) {
                    this.data_to_send.totalContentList = dataList.allContentList.recordSetTotal;
                }

                if (dataList.allContentList.webContentView !== undefined &&
                    dataList.allContentList.webContentView !== null &&
                    Array.isArray(dataList.allContentList.webContentView) &&
                    dataList.allContentList.webContentView.length > 0) {
                    dataList.allContentList.webContentView.map((v, i) => {
                        let here_v = {}
                        if (v['name'] !== undefined) {
                            here_v.name = v['name']
                        }
                        if (v['url'] !== undefined) {
                            // here_v.url = v['url'].includes('onesite-uat5.avnet.com') ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                            here_v.url = v['url'] ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url'];
                        }
                        if (v['shortDescription'] !== undefined) {
                            here_v.shortDesc = v['shortDescription']
                        }
                        if (v['longDescription'] !== undefined) {
                            here_v.longDesc = v['longDescription']
                        }
                        if (v['avn_page_type'] !== undefined) {
                            here_v.pageType = this.getPageType(v['avn_page_type'])
                        }
                        if (v['avn_date'] !== undefined) {
                            here_v.date = Helper.dateFormatFromString(v['avn_date'], true)
                        }
                        if (v['avn_image'] !== undefined) {
                            here_v.image = v['avn_image'];
                        }
                        if (v['avn_startdate'] !== undefined) {
                            here_v.startDate = v['avn_startdate'];
                        }
                        if (v['avn_enddate'] !== undefined) {
                            here_v.endDate = v['avn_enddate'];
                        }
                        if (v['avn_enddate'] !== undefined && v['avn_startdate'] !== undefined) {
                            here_v.eventDate = Helper.dateFormatFromString(v['avn_startdate'], true) + ' - ' + Helper.dateFormatFromString(v['avn_enddate'], true)
                        }
                        if (v['avn_location'] !== undefined) {
                            here_v.location = v['avn_location'];
                        }
                        if (v['avn_image'] !== undefined) {
                            here_v.imageUrl = v['avn_image'];
                        }
                        if (v['avn_author'] !== undefined) {
                            here_v.author = v['avn_author'];
                        }
                        value[i] = here_v;
                    });
                    this.data_to_send.allContentList = value
                }
            }

            // Prepare All Content Video List 
            if (dataList.allContentVideoList !== undefined &&
                dataList.allContentVideoList !== null &&
                dataList.allContentVideoList.webContentView !== undefined &&
                dataList.allContentVideoList.webContentView !== null &&
                Array.isArray(dataList.allContentVideoList.webContentView) &&
                dataList.allContentVideoList.webContentView.length > 0) {
                dataList.allContentVideoList.webContentView.map((v, i) => {
                    let here_v = {}
                    if (v['AssetName'] !== undefined) {
                        here_v.name = v['AssetName']
                    }
                    if (v['LongDescription'] !== undefined) {
                        here_v.longDesc = v['LongDescription']
                    }
                    if (v['AssetUrl'] !== undefined && v['AssetUrl'] != null) {
                        here_v.url = '';
                        if (v['AssetUrl'].includes('||') && v['AssetUrl'].split('||').length > 1) {
                            here_v.url = 'https://players.brightcove.net/4598493563001/BkZJhSKu_default/index.html?videoId=' + v['AssetUrl'].split('||')[2];
                        }
                        else if (v['AssetUrl'] != '' && Helper.checkValidURL(v['AssetUrl'])) {
                            here_v.url = v['AssetUrl'].includes('onesite-uat5.avnet.com') ? System.getRedirectionURL(v['AssetUrl'].replace(/^.*\/\/[^\/]+/, '')) : v['AssetUrl']
                        }
                    }
                    value[i] = here_v;
                });
                this.data_to_send.allContentVideoList = value
            }
            // Prepare Article List
            if (dataList.articleContentList !== undefined &&
                dataList.articleContentList !== null) {
                if (dataList.articleContentList.recordSetTotal !== undefined &&
                    dataList.articleContentList.recordSetTotal !== null &&
                    Number(dataList.articleContentList.recordSetTotal) > 0) {
                    this.data_to_send.totalContentList = dataList.articleContentList.recordSetTotal;
                }

                if (dataList.articleContentList.webContentView !== undefined &&
                    dataList.articleContentList.webContentView !== null &&
                    Array.isArray(dataList.articleContentList.webContentView) &&
                    dataList.articleContentList.webContentView.length > 0) {
                    dataList.articleContentList.webContentView.map((v, i) => {
                        let here_v = {}
                        if (v['name'] !== undefined) {
                            here_v.name = v['name']
                        }
                        if (v['url'] !== undefined) { // Url update
                            // here_v.url = v['url'].includes('onesite-uat5.avnet.com') ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                            here_v.url = v['url'] ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                        }
                        if (v['shortDescription'] !== undefined) {
                            here_v.shortDesc = v['shortDescription']
                        }
                        if (v['longDescription'] !== undefined) {
                            here_v.longDesc = v['longDescription']
                        }
                        if (v['avn_page_type'] !== undefined) {
                            here_v.pageType = this.getPageType(v['avn_page_type'])
                        }
                        if (v['avn_date'] !== undefined) {
                            here_v.date = v['avn_date']
                        }
                        if (v['avn_image'] !== undefined) {
                            here_v.image = v['avn_image'];
                        }
                        value[i] = here_v;
                    });
                    this.data_to_send.articleContentList.list = value
                }

                // Prepare Search Facets
                if (dataList.articleContentList.FacetView !== undefined &&
                    dataList.articleContentList.FacetView !== null &&
                    dataList.articleContentList.FacetView.avn_filters_ntk_cs !== undefined &&
                    dataList.articleContentList.FacetView.avn_filters_ntk_cs !== null &&
                    Array.isArray(dataList.articleContentList.FacetView.avn_filters_ntk_cs) &&
                    dataList.articleContentList.FacetView.avn_filters_ntk_cs.length > 0) {
                    try {
                        let facetObj = {};
                        dataList.articleContentList.FacetView.avn_filters_ntk_cs.map((v, i) => {
                            if (v['name'] !== undefined) {
                                if (v['name'].includes('-') && v['name'].split('-').length > 0) {
                                    let key = v['name'].split('-')[0].trim().replace(/\s/g, "");
                                    if (key !== undefined && key !== null && key !== '') {
                                        // Prepare Array and push data if  key is unique
                                        if (facetObj[key] === undefined) {
                                            facetObj[key] = [];
                                        }
                                        facetObj[key].push({ name: v['name'].split('-')[1], count: v.count })
                                    }
                                }
                            }
                        });
                        if (Object.keys(facetObj).length > 0) {
                            this.data_to_send.articleContentList.searchFacets = facetObj;
                        }
                    } catch (err) {
                        this.data_to_send.articleContentList.searchFacets = {}; // in case of error 
                    }
                }
            }

            // Prepare Events List 
            if (dataList.eventContentList !== undefined &&
                dataList.eventContentList !== null) {
                if (dataList.eventContentList.recordSetTotal !== undefined &&
                    dataList.eventContentList.recordSetTotal !== null &&
                    Number(dataList.eventContentList.recordSetTotal) > 0) {
                    this.data_to_send.totalContentList = dataList.eventContentList.recordSetTotal;
                }

                if (dataList.eventContentList.webContentView !== undefined &&
                    dataList.eventContentList.webContentView !== null &&
                    Array.isArray(dataList.eventContentList.webContentView) &&
                    dataList.eventContentList.webContentView.length > 0) {
                    dataList.eventContentList.webContentView.map((v, i) => {
                        let here_v = {}
                        if (v['name'] !== undefined) {
                            here_v.name = v['name']
                        }
                        if (v['url'] !== undefined) { // url update
                            // here_v.url = v['url'].includes('onesite-uat5.avnet.com') ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                            here_v.url = v['url'] ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                        }
                        if (v['shortDescription'] !== undefined) {
                            here_v.shortDesc = v['shortDescription']
                        }
                        if (v['longDescription'] !== undefined) {
                            here_v.longDesc = v['longDescription']
                        }
                        if (v['avn_page_type'] !== undefined) {
                            here_v.pageType = this.getPageType(v['avn_page_type'])
                        }
                        if (v['avn_date'] !== undefined) {
                            here_v.date = v['avn_date']
                        }
                        if (v['avn_startdate'] !== undefined) {
                            here_v.startDate = v['avn_startdate'];
                        }
                        if (v['avn_enddate'] !== undefined) {
                            here_v.endDate = v['avn_enddate'];
                        }
                        if (v['avn_location'] !== undefined) {
                            here_v.location = v['avn_location'];
                        }

                        if (v['avn_enddate'] !== undefined && v['avn_startdate'] !== undefined) {
                            here_v.eventDate = Helper.dateFormatFromString(v['avn_startdate'], true) + ' - ' + Helper.dateFormatFromString(v['avn_enddate'], true)
                        }
                        value[i] = here_v;
                    });
                    this.data_to_send.eventContentList = value
                }
            }

            // Prepare SitePage List
            if (dataList.sitePageContentList !== undefined &&
                dataList.sitePageContentList !== null) {
                if (dataList.sitePageContentList.recordSetTotal !== undefined &&
                    dataList.sitePageContentList.recordSetTotal !== null &&
                    Number(dataList.sitePageContentList.recordSetTotal) > 0) {
                    this.data_to_send.totalContentList = dataList.sitePageContentList.recordSetTotal;
                }

                if (dataList.sitePageContentList.webContentView !== undefined &&
                    dataList.sitePageContentList.webContentView !== null &&
                    Array.isArray(dataList.sitePageContentList.webContentView) &&
                    dataList.sitePageContentList.webContentView.length > 0) {
                    dataList.sitePageContentList.webContentView.map((v, i) => {
                        let here_v = {}
                        if (v['name'] !== undefined) {
                            here_v.name = v['name']
                        }
                        if (v['url'] !== undefined) { // url content
                            // here_v.url = v['url'].includes('onesite-uat5.avnet.com') ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                            here_v.url = v['url'] ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                        }
                        if (v['shortDescription'] !== undefined) {
                            here_v.shortDesc = v['shortDescription']
                        }
                        if (v['longDescription'] !== undefined) {
                            here_v.longDesc = v['longDescription']
                        }
                        if (v['avn_page_type'] !== undefined) {
                            here_v.pageType = this.getPageType(v['avn_page_type'])
                        }
                        if (v['avn_date'] !== undefined) {
                            here_v.date = v['avn_date']
                        }
                        if (v['avn_image'] !== undefined) {
                            here_v.image = v['avn_image'];
                        }
                        value[i] = here_v;
                    });
                    this.data_to_send.sitePageContentList = value
                }
            }

            // Prepare Video List
            if (dataList.videoContentList !== undefined &&
                dataList.videoContentList !== null) {
                if (dataList.videoContentList.recordSetTotal !== undefined &&
                    dataList.videoContentList.recordSetTotal !== null &&
                    Number(dataList.videoContentList.recordSetTotal) > 0) {
                    this.data_to_send.totalContentList = dataList.videoContentList.recordSetTotal;
                }

                if (dataList.videoContentList.webContentView !== undefined &&
                    dataList.videoContentList.webContentView !== null &&
                    Array.isArray(dataList.videoContentList.webContentView) &&
                    dataList.videoContentList.webContentView.length > 0) {
                    dataList.videoContentList.webContentView.map((v, i) => {
                        let here_v = {}
                        if (v['AssetName'] !== undefined) {
                            here_v.name = v['AssetName']
                        }
                        if (v['LongDescription'] !== undefined) {
                            here_v.longDesc = v['LongDescription']
                        }
                        if (v['AssetUrl'] !== undefined && v['AssetUrl'].includes('||')) {
                            here_v.url = '';
                            if (v['AssetUrl'].split('||').length > 1) {
                                here_v.url = 'https://players.brightcove.net/' + v['AssetUrl'].split('||')[1] + '/BkZJhSKu_default/index.html?videoId=' + v['AssetUrl'].split('||')[2];
                            }
                        }
                        value[i] = here_v;
                    });
                    this.data_to_send.videoContentList.list = value
                }

                // Prepare Search Facets
                if (dataList.videoContentList.FacetView !== undefined &&
                    dataList.videoContentList.FacetView !== null &&
                    dataList.videoContentList.FacetView.avn_filters_ntk_cs !== undefined &&
                    dataList.videoContentList.FacetView.avn_filters_ntk_cs !== null) {
                    let facetArr = [];
                    if (Array.isArray(dataList.videoContentList.FacetView.avn_developmentstage_ntk_cs) &&
                        dataList.videoContentList.FacetView.avn_developmentstage_ntk_cs.length > 0) {
                        facetArr['DevelopmentStage'] = [];
                        dataList.videoContentList.FacetView.avn_developmentstage_ntk_cs.map((v, i) => {
                            facetArr['DevelopmentStage'].push({
                                name: v['name'],
                                count: v.count
                            });
                        });
                    }
                    if (Array.isArray(dataList.videoContentList.FacetView.avn_markets_ntk_cs) &&
                        dataList.videoContentList.FacetView.avn_markets_ntk_cs.length > 0) {
                        facetArr['Markets'] = [];
                        dataList.videoContentList.FacetView.avn_markets_ntk_cs.map((v, i) => {
                            facetArr['Markets'].push({
                                name: v['name'],
                                count: v.count
                            });
                        });
                    }

                    if (Array.isArray(dataList.videoContentList.FacetView.avn_technologies_ntk_cs) &&
                        dataList.videoContentList.FacetView.avn_technologies_ntk_cs.length > 0) {
                        facetArr['Technologies'] = [];
                        dataList.videoContentList.FacetView.avn_technologies_ntk_cs.map((v, i) => {
                            facetArr['Technologies'].push({
                                name: v['name'],
                                count: v.count
                            });
                        });
                    }
                    if (facetArr !== null && Object.keys(facetArr).length > 0) {
                        this.data_to_send.videoContentList.searchFacets = facetArr;
                    }
                }
            }
            // NPI List
            if (dataList.npiContentList !== undefined &&
                dataList.npiContentList !== null) {
                if (dataList.npiContentList.recordSetTotal !== undefined &&
                    dataList.npiContentList.recordSetTotal !== null &&
                    Number(dataList.npiContentList.recordSetTotal) > 0) {
                    this.data_to_send.totalContentList = dataList.npiContentList.recordSetTotal;

                }

                if (dataList.npiContentList.webContentView !== undefined &&
                    dataList.npiContentList.webContentView !== null &&
                    Array.isArray(dataList.npiContentList.webContentView) &&
                    dataList.npiContentList.webContentView.length > 0) {
                    dataList.npiContentList.webContentView.map((v, i) => {
                        let here_v = {}
                        if (v['name'] !== undefined) {
                            here_v.name = v['name']
                        }
                        if (v['longDescription'] !== undefined) {
                            here_v.longDesc = v['longDescription']
                        }
                        if (v['shortDescription'] !== undefined) {
                            here_v.shortDesc = v['shortDescription']
                        }
                        if (v['url'] !== undefined) { // url update
                            // here_v.url = v['url'].includes('onesite-uat5.avnet.com') ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                            here_v.url = v['url'] ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, '')) : v['url']
                        }
                        value[i] = here_v;
                    });
                    this.data_to_send.npiContentList = value
                }
            }
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
    getPageType = (pageType) => {
        let pageText = '';
        switch (pageType.toLowerCase()) {
            case 'marketing':
                pageText = 'Other';
                break;
            case 'articles':
                pageText = 'Article';
                break;
            default:
                pageText = pageType
        }
        return pageText;
    }
}

export default ResponseMaker;